import React from "react";
import aboutBanner from "../assets/about-banner.jpg";
import bannerImg from "../assets/banner-img.png";
import flightIcon from "../assets/pngtree-flying.png";
import hotelIcon from "../assets/pngtree-exterior-hotel.png";
import supportIcon from "../assets/support.png";
import { useTranslation } from 'react-i18next'


const AboutUs = () => {
    const { t } = useTranslation();

  return (
    <>
    
      <section
        className="hero-about-banner"
        style={{ backgroundImage: `url(${aboutBanner})` }}
      >
        <div className="hero-content">
        <h1>{t("bannerTitle")}</h1>
        <p>{t("bannerDesc")}</p>
        </div>
      </section>

      {/* About Section */}
      <section className="about mt-5 mb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="about-text">
                <h2 className="mt-0">{t("whoWeAreTitle")}</h2>
                <p>{t("whoWeAreDesc1")}</p>
                <p>{t("whoWeAreDesc2")}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-img">
                <img src={bannerImg} alt="About TravelX" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services mt-5 mb-5">
        <div className="container">
          <h2>{t("ourServices")}</h2>
          <div className="service-cards">
            <div className="card">
              <img src={flightIcon} alt="Flight Booking" />
              <h3>{t("flightBookingTitle")}</h3>
              <p>{t("flightBookingDesc")}</p>
            </div>
            <div className="card">
              <img src={hotelIcon} alt="Hotel Booking" />
              <h3>{t("hotelBookingTitle")}</h3>
              <p>{t("hotelBookingDesc")}</p>
            </div>
            <div className="card">
              <img src={supportIcon} alt="24/7 Support" />
              <h3>{t("supportTitle")}</h3>
              <p>{t("supportDesc")}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs